import { RECEIVE_CAPITAL_GAINS_TRANSACTIONS, REQUEST_CAPITAL_GAINS_TRANSACTIONS } from '../actions'
import { updateOrAddItemsById } from '../helpers'

export default (
    state = {
        fetchSuccessful: null,
        isFetching: false,
        items: [],
        shouldFetch: true,
    },
    action
) => {
    const { type, data } = action

    switch (type) {
        case REQUEST_CAPITAL_GAINS_TRANSACTIONS:
            return { ...state, isFetching: true, shouldFetch: false }

        case RECEIVE_CAPITAL_GAINS_TRANSACTIONS: {
            const { items: currentItems } = state
            const { items: receivedItems } = data

            const items = updateOrAddItemsById({ currentItems, receivedItems })

            return { ...state, isFetching: false, ...data, items }
        }

        default:
            return state
    }
}
